import { UserState } from './user.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectUserContext =
	createFeatureSelector<UserState>('userContext');

export const selectUser = createSelector(
	selectUserContext,
	(state: UserState) => state.user
);

export const selectUsersList = createSelector(
	selectUserContext,
	(state: UserState) => state.userList
);

export const selectUsersLoading = createSelector(
	selectUserContext,
	(state: UserState) => state.loadingUsers
);

export const selectUserLoading = createSelector(
	selectUserContext,
	(state: UserState) => state.loadingUser
);
